class WorkInstructionPackageDTO {
  _id;
  title;
  workInstructions;
  jobId;

  constructor(data) {
    this._id = data._id || data.id;
    this.title = data.title;
    this.workInstructions = data.workInstructions || [];
    this.jobId = data.jobId;
  }
}

module.exports = WorkInstructionPackageDTO;
